import { CharacterResult } from "./dto/CharacterResult";

export const characterFormDefaultValuesGet = (
  character?: CharacterResult
): CharacterResult => {
  if (character) {
    return {
      id: character.id,
      letter: character.letter,
      meaning: character.meaning,
      pronounce: character.pronounce,
      pronounceAdd: character.pronounceAdd,
      examples: character.examples,
      file: character.file,
      relate: character.relate,
      containCount: character.containCount,
      answer: character.answer,
      topicId: character.topicId,
      position: character.position ?? 0,
    };
  } else {
    return {
      id: "",
      letter: "",
      meaning: "",
      pronounce: "",
      pronounceAdd: [],
      examples: [],
      file: [],
      relate: {},
      containCount: 0,
      answer: {},
      topicId: "",
      position: 0,
    };
  }
};
